import safeJsonParse from '../utils/safeJsonParse';

/**
 * Blog post product card: reflects the selected variant in the visible UI
 * (size label, price, ATC button state).
 *
 * Hidden input[name="id"] sync is handled by product-card-variants.js, which
 * runs against any [data-product-card] form[data-product-form].
 */
const initBlogPostProductCard = (root = document) => {
  const cards = root.querySelectorAll('[data-blog-post-product-card]');
  if (!cards.length) return;

  cards.forEach((card) => {
    if (card.dataset.bpcBound === 'true') return;
    card.dataset.bpcBound = 'true';

    const select = card.querySelector('[data-variant-select]');
    const variantsScript = card.querySelector('script[data-variants]');
    const sizeLabel = card.querySelector('[data-size-label]');
    const priceLabel = card.querySelector('[data-price]');
    const atcButton = card.querySelector('[data-atc-button]');
    const atcLabel = card.querySelector('[data-atc-label]');

    if (!select || !variantsScript) return;

    const variants = safeJsonParse(variantsScript.textContent) || {};

    select.addEventListener('change', () => {
      const data = variants[select.value];
      if (!data) return;

      if (sizeLabel && data.size != null) sizeLabel.textContent = data.size;
      if (priceLabel && data.price != null) priceLabel.textContent = data.price;

      if (atcButton) {
        const available = data.available === true;
        atcButton.disabled = !available;
        if (atcLabel) {
          atcLabel.textContent = available
            ? atcButton.dataset.labelAdd
            : atcButton.dataset.labelSoldOut;
        }
      }
    });
  });
};

export default initBlogPostProductCard;
